export default __webpack_public_path__ + "static/media/mystery-bet.f254a7aa.png";